import {CancellationReason} from "@bounce/shared/consumer/declarations";
import {CancelPaymentPlanDialogContent} from "@bounce/shared/consumer/pages/account-dashboard";
import NiceModal, {NiceModalHocProps, useModal} from "@ebay/nice-modal-react";
import React, {useCallback, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useDeactivatePaymentPlanForAccount} from "~/api/requests";
import {Pages} from "~/bi-events/enum";
import {useAmplitude} from "~/contexts";
import {urls} from "~/routes/consumerUrls";

interface CancelPaymentPlanDialogProps extends NiceModalHocProps {
  accountId: string;
  activePaymentPlanId: string;
  originalBalance: number;
  shouldDisplayRewardsWarning: boolean;
}

const CancelPaymentPlanDialog = NiceModal.create(({accountId, activePaymentPlanId}: CancelPaymentPlanDialogProps) => {
  const {pageClickEvent} = useAmplitude();
  const navigate = useNavigate();
  const modal = useModal();

  const [selectedReason, setSelectedReason] = useState<CancellationReason>();
  const [freeText, setFreeText] = useState<string>("");

  const deactivateState = useDeactivatePaymentPlanForAccount({refetchType: "all"});

  const cancelPaymentPlanHandler = useCallback(async (): Promise<void> => {
    if (activePaymentPlanId && selectedReason) {
      try {
        const result = await deactivateState.mutateAsync({
          account_id: accountId,
          payment_plan_id: activePaymentPlanId,
          revoked_data: {
            reason: selectedReason,
            extra: selectedReason === "other" ? freeText : undefined,
            cancelled_by: "user",
          },
        });
        if (result) {
          modal.resolve(true);
          modal.hide();
        }
      } catch (e) {
      } finally {
        pageClickEvent({page: Pages.CANCELLATION_REASONS, cta: "confirm_cancel", data: {reason: selectedReason}});
        navigate(urls.accounts.url);
      }
    }
  }, [activePaymentPlanId, selectedReason, freeText]);

  const handleLeavePlan = useCallback((): void => {
    pageClickEvent({page: Pages.CANCELLATION_REASONS, cta: "leave"});
  }, []);

  return (
    <CancelPaymentPlanDialogContent
      selectedReason={selectedReason}
      onSelectReason={setSelectedReason}
      freeText={freeText}
      onChangeFreeText={setFreeText}
      cancelPaymentPlanHandler={cancelPaymentPlanHandler}
      handleLeavePlan={handleLeavePlan}
    />
  );
});

export default CancelPaymentPlanDialog;
